import React from 'react'
import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'
import MainLayout from 'features/shared/layouts/main'
import { PrimaryButton } from '@gr-monorepo/common/public/ui/Buttons'
import { supportEmail } from '@gr-monorepo/common/public/ui/constants'

const MAIN_PAGE_PATH = '/main'

const Page = styled.div`
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 0;
  box-sizing: border-box;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  text-align: center;
`

const Title = styled.h1`
  margin: 0;
  font-size: 40px;
  font-weight: 700;
  line-height: 1.2;
  color: var(--font-color);
`

const Text = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 22px;
`

const inlineLinkStyles = css`
  && {
    color: var(--primary-base);
    text-decoration: underline;
  }

  &&:hover,
  &&:focus {
    color: var(--primary-base);
    text-decoration: underline;
    opacity: 0.85;
  }
`

const InlineLink = styled(Link)`
  ${inlineLinkStyles}
`

const ExternalLink = styled.a`
  ${inlineLinkStyles}
`

const BackLink = styled(Link)`
  padding-top: 12px;
  text-decoration: none;
`

export const Error404Page = () => (
  <MainLayout>
    <Page data-testid="error-404-page">
      <Content>
        <Title>Ошибка 404</Title>
        <Text>
          Такой страницы нет. Вы можете вернуться на{' '}
          <InlineLink to={MAIN_PAGE_PATH}>главную</InlineLink>
        </Text>
        <BackLink to={MAIN_PAGE_PATH}>
          <PrimaryButton size="xlarge">Вернуться</PrimaryButton>
        </BackLink>
      </Content>
    </Page>
  </MainLayout>
)

export const Error500Page = () => (
  <MainLayout>
    <Page data-testid="error-500-page">
      <Content>
        <Title>Ошибка 500</Title>
        <Text>
          Сайт временно недоступен. Зайдите позже или напишите <br /> в&nbsp;поддержку:{' '}
          <ExternalLink href={`mailto:${supportEmail}`}>{supportEmail}</ExternalLink>
        </Text>
        <BackLink to={MAIN_PAGE_PATH}>
          <PrimaryButton size="xlarge">Вернуться</PrimaryButton>
        </BackLink>
      </Content>
    </Page>
  </MainLayout>
)
